import React, { Component, Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import OnlineCatalogDownloadButton from '../Components/OnlineCatalogDownloadButton';
import OnlineCatalogViewer from '../Components/OnlineCatalogViewer'
import { getCatalog } from '../Actions/OnlineCatalog.action';

const OnlineCatalogContainer = props => {
    //class OnlineCatalogContainer extends Component {
    useEffect(() => {
        props.getCatalog();
        const canvasEl = document.querySelector('.online-catalog-canvas');

        if (canvasEl) {
            canvasEl.classList.add('active');
        }
    }, []);

    useEffect(() => {
        if (props.leftPageSet && props.rightPageSet) {
            setTimeout(function () {
                    window.__litium.initBuyButtons();
                },
                500);
        }
    }, [props.leftPageSet, props.rightPageSet]);

    return (
        <Fragment>
            <OnlineCatalogViewer {...props} />
        </Fragment>
    )
}


const mapStateToProps = state => {
    return {
        currentPage: state.onlineCatalog.currentPage,
        rightPageSet: state.onlineCatalog.rightPageSet,
        leftPageSet: state.onlineCatalog.leftPageSet
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getCatalog: () => dispatch(getCatalog()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OnlineCatalogContainer);